/**
 * Rewardful affiliate tracking helper.
 * Reads the referral ID set by Rewardful's rw.js script.
 */
export const getRewardfulReferral = (): string | undefined => {
  try {
    return (window as unknown as { Rewardful?: { referral?: string } }).Rewardful?.referral || undefined;
  } catch {
    return undefined;
  }
};
